import { useState } from 'react';
import { API_BASE } from '../lib/config';

function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit() {
    if (!message.trim()) return;
    setSubmitting(true);
    const userId = sessionStorage.getItem('carpeUserId');
    try {
      const res = await fetch(`${API_BASE}/feedback/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message,
          user_id: userId,
          page_context: window.location.pathname,
        }),
      });
      if (res.ok) {
        setSubmitted(true);
        setMessage('');
      } else {
        console.error('Feedback submission failed:', await res.text());
      }
    } catch (err) {
      console.error('Feedback submission error:', err);
    }
    setSubmitting(false);
  }

  function handleClose() {
    setOpen(false);
    setSubmitted(false);
  }

  return (
    <>
      <button style={styles.floatingBtn} onClick={() => setOpen(true)}>
        💬 Feedback
      </button>
      {open && (
        <div style={styles.overlay} onClick={handleClose}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            {submitted ? (
              <>
                <div style={styles.thanks}>Thank you! Your feedback helps shape Carpe Wonder.</div>
                <button style={styles.closeBtn} onClick={handleClose}>Close</button>
              </>
            ) : (
              <>
                <div style={styles.title}>Got feedback?</div>
                <div style={styles.subtitle}>Tell us what's working, what's not, or what you wish existed.</div>
                <textarea
                  style={styles.textarea}
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  placeholder="Type your feedback here..."
                  rows={5}
                />
                <div style={styles.btnRow}>
                  <button style={styles.cancelBtn} onClick={handleClose}>Cancel</button>
                  <button
                    style={{
                      ...styles.submitBtn,
                      opacity: message.trim() && !submitting ? 1 : 0.5,
                      cursor: message.trim() && !submitting ? 'pointer' : 'not-allowed',
                    }}
                    onClick={handleSubmit}
                    disabled={!message.trim() || submitting}
                  >
                    {submitting ? 'Sending...' : 'Send feedback'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  floatingBtn: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    background: 'var(--gold)',
    color: '#0d0d1f',
    border: 'none',
    borderRadius: '24px',
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
    zIndex: 999,
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px',
  },
  modal: {
    background: '#1a1a2e',
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '420px',
    width: '100%',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  title: { fontSize: '18px', fontWeight: '700', color: '#fff', marginBottom: '6px' },
  subtitle: { fontSize: '13px', color: 'rgba(255,255,255,0.6)', marginBottom: '14px' },
  textarea: {
    width: '100%',
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '8px',
    padding: '10px',
    color: '#fff',
    fontSize: '14px',
    fontFamily: 'inherit',
    resize: 'vertical',
    marginBottom: '14px',
    boxSizing: 'border-box',
  },
  btnRow: { display: 'flex', justifyContent: 'flex-end', gap: '10px' },
  cancelBtn: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.2)',
    color: 'rgba(255,255,255,0.7)',
    borderRadius: '20px',
    padding: '8px 16px',
    fontSize: '13px',
    cursor: 'pointer',
  },
  submitBtn: {
    background: 'var(--gold)',
    border: 'none',
    color: '#0d0d1f',
    borderRadius: '20px',
    padding: '8px 16px',
    fontSize: '13px',
    fontWeight: '600',
  },
  thanks: { fontSize: '15px', color: '#fff', marginBottom: '16px', textAlign: 'center' },
  closeBtn: {
    background: 'var(--gold)',
    border: 'none',
    color: '#0d0d1f',
    borderRadius: '20px',
    padding: '8px 16px',
    fontSize: '13px',
    fontWeight: '600',
    width: '100%',
    cursor: 'pointer',
  },
};

export default FeedbackButton;